<template>
  <div v-if="hasAccess">
    <page-submenu :links="links" />
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageSubmenu from '@/components/PageSubmenu.vue'

export default {
  name: 'app-dashboard-tracking-management',
  components: {
    PageSubmenu
  },
  computed: {
    ...mapGetters(['roles']),
    hasAccess () {
      return this.roles.some(role => ['admin', 'community-manager'].includes(role))
    },
    links () {
      return [
        {
          label: 'Messagerie',
          path: '/app/dashboard/tracking/management/messaging',
          roles: ['admin', 'community-manager']
        },
        {
          label: 'Équipe CM',
          path: '/app/dashboard/tracking/management/team',
          roles: ['admin', 'community-manager']
        },
        {
          label: 'Domaines',
          path: '/app/dashboard/tracking/management/domains',
          activePrefix: '/app/dashboard/tracking/management/domains',
          roles: ['admin', 'community-manager']
        },
        {
          label: 'Versions',
          path: '/app/dashboard/tracking/management/versions',
          roles: ['admin']
        }
      ]
    }
  }
}
</script>
